// src/config/petBreedImages.js
import golden from "../assets/golden.webp";
import buldog from "../assets/buldog.webp";
import pastor from "../assets/pastor.webp";
import pug from "../assets/pug.webp";
import fila from "../assets/fila.webp";
import terrier from "../assets/terrier.webp";
import pomeranian from "../assets/pomeranian.webp";
import salchicha from "../assets/salchicha.webp";
import dober from "../assets/dober.webp";
import pitbull from "../assets/pitbull.webp";
import poodle from "../assets/poodle.webp";
import dalmata from "../assets/dalmata.webp";
import beagle from "../assets/beagle.webp";
import australiano from "../assets/australiano.webp";
import pinscher from "../assets/pinscher.webp";
import cooker from "../assets/cooker.webp";
import labrador from "../assets/labrador.webp";
import labradorN from "../assets/labradorN.webp";
import airdale from "../assets/Airedale.webp";
import akita from "../assets/akita.webp";
import akitaA from "../assets/akitaA.webp";
import malamute from "../assets/Malamute.webp";
import bully from "../assets/Bully.webp";
import staff from "../assets/staff.webp";
import basenji from "../assets/basenji.webp";
import basset from "../assets/Basset-Hound.webp";
import collie from "../assets/collie.webp";
import bichonB from "../assets/Bichon-B.webp";
import bichonF from "../assets/bichonF.webp";
import havanese from "../assets/Havanese.webp";
import sabueso from "../assets/sabueso.webp";
import bobtail from "../assets/bobtail.webp";
import borderC from "../assets/border-c.webp";
import boston from "../assets/bostont.webp";
import boxer from "../assets/boxer.webp";
import boyero from "../assets/boyero.webp";
import braco from "../assets/braco.webp";
import bullterrier from "../assets/bullterrier.webp";
import bulldogA from "../assets/bulldoga.webp";
import bulldogI from "../assets/bulldogi.webp";
import bullmastiff from "../assets/BULLMASTIFF.webp";
import cairn from "../assets/cairn.webp";
import mastin from "../assets/mastin.webp";
import caniche from "../assets/caniche.webp";
import cavalier from "../assets/Cavalier.webp";
import chihuahua from "../assets/chihuahua.webp";
import chow from "../assets/chow.webp";
import collieO from "../assets/collieO.webp";
import corgip from "../assets/corgip.webp";
import cardigan from "../assets/cardigan.webp";
import dogoA from "../assets/dogoA.webp";
import dogoB from "../assets/dogoBjpg.webp";
import fox from "../assets/fox.webp";
import foxh from "../assets/foxh.webp";
import frenchton from "../assets/frenchton.webp";
import galgo from "../assets/galgo.webp";
import grandanes from "../assets/grandanes.webp";
import arlequin from "../assets/grandanesE.webp";
import pirineo from "../assets/pirineo.webp";
import husky from "../assets/husky.webp";
import jack from "../assets/jack.webp";
import keeshond from "../assets/keeshond.webp";
import lhasa from "../assets/Lhasa.webp";
import lobero from "../assets/lobero.webp";
import maltes from "../assets/maltes.webp";
import manchester from "../assets/manchester.webp";
import mastinE from "../assets/mastinE.webp";
import napolitano from "../assets/napolitano.webp";
import tibetano from "../assets/tibetano.webp";
import schnauzer from "../assets/schnauzer.webp";
import papillon from "../assets/papillon.webp";
import belga from "../assets/belga.webp";
import blanco from "../assets/blanco.webp";
import catalan from "../assets/catalan.webp";
import holandes from "../assets/holandes.webp";
import pequines from "../assets/pequines.webp";
import perroA from "../assets/PerroAgua.webp";
import shetland from "../assets/shetland.webp";
import rhodesian from "../assets/rhodesian.webp";
import rottweiler from "../assets/rottweiler.webp";
import sanBernardo from "../assets/sanB.webp";
import schipperke from "../assets/schipperke.webp";
import shar from "../assets/shar.webp";
import shiba from "../assets/shiba.webp";
import shih from "../assets/shih.webp";
import terranova from "../assets/terranova.webp";
import terrierE from "../assets/TerrierE.webp";
import terrierG from "../assets/terrierG.webp";
import terrierI from "../assets/terrier-irlandes.webp";
import vizsla from "../assets/vizsla.webp";
import white from "../assets/West.webp";
import salchipug from "../assets/salchipug.webp";
import bigrope from "../assets/bigrope.webp";

import mestizo from "../assets/mestizo.webp";
import criollo from "../assets/criollo.webp";

import persa from "../assets/persa.webp";
import siames from "../assets/sia.webp";
import ruso from "../assets/ruso.webp";
import maine from "../assets/maine.webp";
import bengali from "../assets/bengali.webp";
import ragdoll from "../assets/ragdoll.webp";
import esfinge from "../assets/esfinge.webp";
import siberiano from "../assets/siberiano.webp";
import angora from "../assets/angora.webp";
import samoyedo from "../assets/samoyedo.webp";
import abisinio from "../assets/abisinio.webp";
import bobtailA from "../assets/american-bobtail.webp";
import curl from "../assets/American-Curl.webp";
import corto from "../assets/corto.webp";
import duro from "../assets/duro.webp";
import mist from "../assets/mist.webp";
import balines from "../assets/Balines.webp";
import birmano from "../assets/birmano.webp";
import japones from "../assets/japones.webp";
import bombay from "../assets/bombay.webp";
import bosque from "../assets/bosque.webp";
import largo from "../assets/Largo.webp";
import cortoB from "../assets/cortoB.webp";
import california from "../assets/calendario.webp";
import chartreux from "../assets/chartreux-cat.webp";
import devon from "../assets/devon.webp";
import don from "../assets/don.webp";
import exotico from "../assets/exotico.webp";
import himalayo from "../assets/HIMALAYO.webp";
import khao from "../assets/khao.webp";
import javanes from "../assets/javanes.webp";
import laperm from "../assets/LaPerm_cat.webp";
import mau from "../assets/Mau.webp";
import min from "../assets/min.webp";
import neb from "../assets/neb.webp";
import rex from "../assets/rex.webp";
import savannah from "../assets/savannah.webp";
import scottich from "../assets/Scottish.webp";
import singapura from "../assets/singapura.webp";
import snow from "../assets/snow.webp";
import sokoke from "../assets/sokoke.webp";
import somali from "../assets/Somali.webp";
import van from "../assets/Van.webp";

const DOG_IMAGES = {
  "bulldog frances": buldog,
  "bulldog francés": buldog,
  "doberman": dober,
  "fila brasilero": fila,
  "golden retriever": golden,
  "pastor aleman": pastor,
  "pastor alemán": pastor,
  "pomeranian": pomeranian,
  "perro salchicha": salchicha,
  "yorkshire terrier": terrier,
  "pug": pug,
  "pitbull": pitbull,
  "poodle": poodle,
  "dalmata": dalmata,
  "dálmata": dalmata,
  "beagle": beagle,
  "pastor australiano": australiano,
  "pinscher": pinscher,
  "cocker spaniel": cooker,
  "labrador dorado": labrador,
  "labrador negro": labradorN,
  "airdale terrier": airdale,
  "akita": akita,
  "akita americano": akitaA,
  "malamute de alaska": malamute,
  "bully americano": bully,
  "staffordshine terrier americano": staff,
  "american staffordshire terrier": staff,
  "basenji": basenji,
  "basset hound": basset,
  "collie barbudo": collie,
  "bichon boloñes": bichonB,
  "bichón boloñés": bichonB,
  "bichon frances": bichonF,
  "bichón francés": bichonF,
  "bichon habanero": havanese,
  "bichón habanero": havanese,
  "sabueso": sabueso,
  "bobtail": bobtail,
  "border collie": borderC,
  "boston terrier": boston,
  "boxer": boxer,
  "bóxer": boxer,
  "boyero de berna": boyero,
  "braco de weimar": braco,
  "bull terrier": bullterrier,
  "bulldog americano": bulldogA,
  "bulldog inglés": bulldogI,
  "bulldog ingles": bulldogI,
  "bullmastiff": bullmastiff,
  "cairn terrier": cairn,
  "mastin italiano": mastin,
  "mastín italiano": mastin,
  "caniche": caniche,
  "cavalier king charles spaniel": cavalier,
  "chihuahua": chihuahua,
  "chow chow": chow,
  "collie": collieO,
  "corgi gales pembroke": corgip,
  "corgi galés pembroke": corgip,
  "corgi gales cardigan": cardigan,
  "corgi galés cardigan": cardigan,
  "teckel": salchicha,
  "dogo argentino": dogoA,
  "dogo de burdeos": dogoB,
  "fox terrier": fox,
  "foxhound": foxh,
  "frenchton": frenchton,
  "galgo": galgo,
  "gran danes": grandanes,
  "gran danés": grandanes,
  "gran danes arlequin": arlequin,
  "gran danés arlequín": arlequin,
  "gran pirineo": pirineo,
  "husky siberiano": husky,
  "jack russell terrier": jack,
  "keeshond": keeshond,
  "lhasa apso": lhasa,
  "lobero irlandes": lobero,
  "lobero irlandés": lobero,
  "maltes": maltes,
  "maltés": maltes,
  "manchester terrier": manchester,
  "mastin español": mastinE,
  "mastín español": mastinE,
  "mastin napolitano": napolitano,
  "mastín napolitano": napolitano,
  "mastin tibetano": tibetano,
  "mastín tibetano": tibetano,
  "schnauzer miniatura": schnauzer,
  "papillon": papillon,
  "papillón": papillon,
  "pastor belga": belga,
  "pastor blanco suizo": blanco,
  "pastor catalan": catalan,
  "pastor catalán": catalan,
  "pastor holandés": holandes,
  "pastor holandes": holandes,
  "pequinés": pequines,
  "pequines": pequines,
  "perro de agual español": perroA,
  "pastor de shetland": shetland,
  "rhodesian ridgeback": rhodesian,
  "rottweiler": rottweiler,
  "san bernardo": sanBernardo,
  "samoyedo": samoyedo,
  "schipperke": schipperke,
  "shar pei": shar,
  "shiba inu": shiba,
  "shih tzu": shih,
  "terranova": terranova,
  "terrier escocés": terrierE,
  "terrier escoces": terrierE,
  "terrier gales": terrierG,
  "terrier galés": terrierG,
  "terrier irlandes": terrierI,
  "terrier irlandés": terrierI,
  "vizsla": vizsla,
  "west highland white terrier": white,
  "salchipug": salchipug,
  "big rope": bigrope,
  "fluffy": bigrope,


  // ✅ PERRO: Mestizo o Criollo
  "mestizo": mestizo,
  "criollo": mestizo,
};

const CAT_IMAGES = {
  "persa": persa,
  "siamés": siames,
  "siames": siames,
  "azul ruso": ruso,
  "maine coon": maine,
  "bengalí": bengali,
  "bengali": bengali,
  "ragdoll": ragdoll,
  "esfinge": esfinge,
  "siberiano": siberiano,
  "angora": angora,
  "abisinio": abisinio,
  "bobtail americano": bobtailA,
  "curl americano": curl,
  "americano de pelo corto": corto,
  "americano de pelo duro": duro,
  "australian mist": mist,
  "balines": balines,
  "balinés": balines,
  "birmano": birmano,
  "bobtail japones": japones,
  "bobtail japonés": japones,
  "bombay": bombay,
  "bosque de noruega": bosque,
  "britanico de pelo largo": largo,
  "británico de pelo largo": largo,
  "británico de pelo corto": cortoB,
  "britanico de pelo corto": cortoB,
  "california spangled": california,
  "chartreux": chartreux,
  "devon rex": devon,
  "don esfinge": don,
  "exotico de pelo corto": exotico,
  "exótico de pelo corto": exotico,
  "himalayo": himalayo,
  "khao manee": khao,
  "javanes": javanes,
  "javanés": javanes,
  "laperm": laperm,
  "mau egipcio": mau,
  "minskin": min,
  "nebelung": neb,
  "selkirk rex": rex,
  "savannah": savannah,
  "scottish fold": scottich,
  "singapura": singapura,
  "snowshoe": snow,
  "sokoke": sokoke,
  "somalí": somali,
  "somali": somali,
  "van turco": van,


  // ✅ GATO: Mestizo o Criollo
  "mestizo": criollo,
  "criollo": criollo,
};

export function getBreedImage(tipoMascota, raza) {
  if (!raza) return null;
  const key = raza.trim().toLowerCase();
  const map = tipoMascota === "Gato" ? CAT_IMAGES : DOG_IMAGES;
  return map[key] || null;
}
